import { Outlet } from "react-router-dom";
import CreateGlobalStyle from "commons/styles/globalStyles.styled";

export default function App() {
  return (
    <>
      <CreateGlobalStyle />
      <Outlet />
    </>
  );
}